import { kwls } from '@config';
const BaseView = require('./base');
const ImagesFactory = require('../../../factory/images');
const searchOptionsTemplate = require('./search-options.hbs');

module.exports = BaseView.extend({
  type: 'mns',
  events: _.extend({
    'click .item .content': 'toggleThumbnailEvent'
  }, BaseView.prototype.events),

  thumbSize: {
    width: 240,
    height: 118
  },

  initialize: function () {
    this.mnsServer = INKIVE.C.IS_DEV || INKIVE.C.IS_QA
      ? 'qa-kong.command-api.kw.com'
      : 'kong.command-api.kw.com';

    BaseView.prototype.initialize.call(this);
  },

  searchClickEvent: function (event) {
    this.$searchOptions && this.$searchOptions.toggle();
  },

  selectSearchOptionEvent: function (event) {
    const $target = $(event.currentTarget);
    const $options = this.getSearchOptions().find('> div');

    $target.is($options) && this.selectOption($target, $options);
    $options.closest('.search-container').children('input').focus();
  },

  selectOption: function ($target, $options) {
    $options = $options || this.getSearchOptions().find('> div');
    const $input = this.getSearchOptions().siblings('input');

    $options.removeClass('selected');
    $options.find('.desygner-icon-check').prependTo($target);
    $target.addClass('selected');

    $input.attr('placeholder', $target.text().trim());
  },

  getSearchOptions: function () {
    if (!this.$searchOptions) {
      this.$searchOptions = $(searchOptionsTemplate({ type: 'mns', isMns: true }));
    }

    return this.$searchOptions;
  },

  getSearchUrl: function (val) {
    let url = 'https://' + this.mnsServer;
    this.searchType = this.getSearchOptions().find('.selected').data('key');

    if (this.searchType === 'neighborhood') {
      url += '/v2/boundaries/boundary-search?q=';
    } else if (this.searchType === 'postal_code') {
      url += '/mns/image-snap/generate?process=image_direct&zip_code=';
    }

    url += val + '&filter[boundary_type]=neighborhood&page[limit]=10&page[offset]=';

    return url;
  },

  searchCallback: function (elems) {
    if (this.searchType === 'postal_code') {
      this.processImageThumbnail(this.$el.find('.thumbnail-wrapper'), { data: elems });
      this.$el.find('.antiscroll-inner').css('height', '100%');
    } else {
      BaseView.prototype.searchCallback.call(this, elems);
    }
  },

  mapResult: function (item) {
    const property = item._source.properties;

    return {
      id: property.db_id,
      neighborhood: property.label,
      city: property.city,
      state: property.state_prov,
      country: property.country
    };
  },

  toggleThumbnailEvent: function (event) {
    const $target = $(event.currentTarget).parent();
    const $thumbnail = $target.find('.thumbnail-wrapper');
    const shown = !!$thumbnail.height();

    if (shown) {
      INKIVE.Modal.loaderClose($thumbnail);
      $thumbnail.height(0);
    } else if ($thumbnail.html()) {
      let height = 40;
      $thumbnail.find('.thumbnail').each(function () {
        height += ($(this).height());
      });
      $thumbnail.height(height);
    } else {
      $thumbnail.height(100);
      this.getImageThumbnail($thumbnail, $target.data('id'), event);
    }

    $target.find('.desygner-icon-arrow-up').toggleClass('hidden', shown);
    $target.find('.desygner-icon-arrow-down').toggleClass('hidden', !shown);
  },

  getImageThumbnail: function ($thumbnail, id) {
    const url = 'https://' + this.mnsServer + '/mns/image-snap/generate?process=image_direct&neighborhood_id=' + id;

    _.delay(_.partial(INKIVE.Modal.loader, $thumbnail), 500);

    $.ajax({
      url,
      method: 'GET',
      headers: kwls.headers
    }).then(_.bind(_.partial(this.processImageThumbnail, $thumbnail), this),
      function (error) {
        _.delay(function () {
          $thumbnail.html('<div class="loading-error">Error loading thumbnails</div>');
        }, 600);
      });
  },

  processImageThumbnail: function ($thumbnail, snapshotData) {
    if (!snapshotData.data.image_orientation_urls) {
      snapshotData.data.image_orientation_urls = {
        290: { landscape: snapshotData.data.image_urls[290] },
        1200: { landscape: snapshotData.data.image_urls[1200] }
      };
    }

    const thumbs = snapshotData.data.image_orientation_urls[290];
    const imageLoadedCallback = _.bind(function (orientation, status) {
      status === INKIVE.C.Status.success && this.addImageThumbnail($thumbnail, snapshotData, orientation);
    }, this);

    _.each(thumbs, _.bind(function (url, orientation) {
      ImagesFactory.smartLoad(url, this.thumbSize, _.partial(imageLoadedCallback, orientation), true);
    }, this));
  },

  addImageThumbnail: function ($thumbnail, snapshotData, orientation) {
    const callback = _.bind(this.tool.callbackImages, this.tool);
    const thumbSrc = snapshotData.data.image_orientation_urls[290][orientation];
    const img = new Image();
    const isPortrait = orientation === 'portrait';
    img.src = thumbSrc;
    img.onload = _.bind(function () {
      const width = isPortrait ? 150 : 232;
      const ratio = img.width / width;
      const height = img.height / ratio;

      const thumbSize = {
        width,
        height
      };

      const item = _.extend({
        id: 'photo-mns-' + snapshotData.data.neighborhood_id,
        data: {
          external: true,
          version: {
            thumb: thumbSrc,
            original: snapshotData.data.image_orientation_urls[1200][orientation]
          }
        }
      }, thumbSize);

      if ($thumbnail.find('.loader-wrapper').length) {
        $thumbnail.height(0);
        INKIVE.Modal.loaderClose($thumbnail);
      }

      this.tool.addThumbItem($thumbnail, [item], callback);
    }, this);
  }
});
